import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TrainingPart1Component } from './training-part1/training-part1.component';
import { MaterialModule} from '../material/material.module'



@NgModule({
  declarations: [TrainingPart1Component],
  imports: [
    CommonModule,
    MaterialModule
  ],
  exports: [
    TrainingPart1Component
  ]
})
export class TrainingModule { }
